import { moduleProviderFactory } from 'core/providers';
import { ReceivingList, ReceivingEdit, ReceivingDetail } from 'modules/receiving/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.receiving',
				pattern: '/containers',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.receiving.list',
						pattern: '',
						component: ReceivingList,
					},
					{
						name: 'master.app.main.receiving.list.add',
						pattern: '/add',
						component: ReceivingEdit,
					},
					{
						name: 'master.app.main.receiving.list.edit',
						pattern: '/edit/:id',
						component: ReceivingEdit,
					},
					{
						name: 'master.app.main.receiving.list.detail',
						pattern: '/detail/:id',
						component: ReceivingDetail,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/receiving/config.js